// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"a85b2e49","488":"f87f8061","977":"5d9c67ca"}[chunkId] + ".chunk.js";
};